module.exports = __webpack_public_path__ + "a147192f6715b2421227e833980c8705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formFactors/turret.png
// module id = 1646
// module chunks = 5